<template>
    <div>
        <ui-modal ref="buyInModal" class="definition-modal" title="Buy Back Vehicle" dismiss-on="close-button esc" @close="$emit('close')">

            <div v-if="instance && purchaseData" class="container-fluid" style="padding: 0; margin-top: 1rem;">

                <div class="row align-items-center">
                    <div class="col">
                        <div class="ui-textbox__label-text">Base Description</div>
                        <div style="font-size: 1rem;">
                            <span style="display: inline-block; width: 80%;">
                                {{ this.instance.vehicle.manufacturer.name }} 
                                {{ this.instance.vehicle.model.name}} 
                                {{ this.instance.vehicle.derivative }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="row" style="margin-top: 1rem;">
                    <div class="col">
                        <ui-textbox
                            label="Current Registration"
                            v-model="purchaseData.registration"
                            class="reg"
                            placeholder="VRM"
                        ></ui-textbox>
                    </div>
                    <div class="col">
                        <ui-textbox
                            label="Vehicle Identification #"
                            placeholder="VIN"
                            v-model="purchaseData.vin"
                            class="reg vin"
                            :disabled="true"
                        ></ui-textbox>
                    </div>
                </div>

                <div class="row">
                     <div class="col">
                        <ui-textbox
                            label="Mileage"
                            v-model="purchaseData.miles"
                            :invalid="purchaseData.miles === '' || purchaseData.miles <= 0"
                        ></ui-textbox>
                    </div>
                    <div class="col">
                        <ui-textbox
                            label="Owners"
                            v-model="purchaseData.owners"
                        ></ui-textbox>
                    </div>
                </div>

                <hr style="margin-bottom: 1.5rem;">

                <!-- Purchase Details !-->
                <div  class="row">
                    <div class="col">
                        <div class="meta-container">
                            <h5>Purchase Details</h5>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <contact-picker
                        ref="picker"
                            label="Purchasing From"
                            v-model="purchaseData.supplier"
                        ></contact-picker>
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="col">
                        <ui-textbox
                            label="Price Given £'s"
                            v-model="purchaseData.price_given"
                            help="Including any VAT"
                        ></ui-textbox>
                    </div>
                    <div class="col">
                        <ui-switch 
                            v-model="purchaseData.vat_rate" 
                            :trueValue="VatTariffs.STANDARD" 
                            :falseValue="VatTariffs.NONE"
                            style="margin-bottom: 0;"
                            label="VAT Qualifying"
                        ></ui-switch>
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="col">
                        <location-picker 
                            label="Stock Location" 
                            v-model="location"
                        ></location-picker>
                    </div>
                    <div class="col">
                        <ui-datepicker
                            label="Purchase Date"
                            v-model="purchaseData.purchase_date"
                            :start-of-week="1"
                        ></ui-datepicker>
                    </div>
                </div>

                <!-- Settlement Details !-->
                <div>
                    <div class="row">
                        <div class="col">
                            <div class="meta-container">
                                <h5>Settlement Details</h5>
                            </div>
                        </div>
                    </div>

                    <ui-switch
                        v-model="showSettlement"
                        style="margin-bottom: 1rem;">Does this vehicle have outstanding financing?</ui-switch>

                    <finance-settlement-pane
                        ref="settlementPane"
                        v-show="showSettlement"
                        style="margin-bottom: 1rem;"
                    ></finance-settlement-pane>
                </div>

            </div>

            <div slot="footer">
                <button class="btn btn-primary" @click="buy" :disabled="!canSubmit">Buy</button>
            </div>
        </ui-modal>

        <vehicle-added-modal ref="added" :loaded="isLoaded" :show-add-another="false"></vehicle-added-modal>
    </div>
</template>

<script>
    import Filters from '../../../filters'
    import VehicleAddedModal from './VehicleAddedModal'
    import { VehicleInstanceResource } from '../../../classes/Api/Vehicle';
    import ContactPicker from '../controls/KeenContactPicker'
    import LocationPicker from '../controls/KeenLocationPicker'
    import { mapMutations } from 'vuex'
    import { VatTariffs } from '../../../classes/VatService'
    import { FinanceSettlementPane } from "../../finance";

    export default {
        filters: Filters,
        components: {FinanceSettlementPane, ContactPicker, VehicleAddedModal, LocationPicker },
        data() {
            return {
                purchaseData: {
                    manufacturer: null,
                    model: null,
                    derivative: null,
                    registration: null,
                    vin: null,
                    miles: null,
                    supplier: null,
                    owners: null,
                    vat_rate: null,
                    location_id: null,
                    purchase_date: null,
                },
                location: window.marque.ui.location,
                instance: null,
                isLoaded: false,
                showSettlement: false,
                VatTariffs,
            }
        },
        created() {
            setInterval(() => {
                if (this.showSettlement && this.$refs.settlementPane) {
                    console.log(this.$refs.settlementPane.settlementValid)
                }
            }, 1000)
        },
        computed: {
            canSubmit() {
                return this.purchaseData && this.purchaseData.supplier && this.purchaseData.supplier.id &&
                    this.purchaseData.price_given > 0 &&
                    this.purchaseData.miles > 0 &&
                    this.purchaseData.owners > 0 &&
                    (!this.showSettlement || this.showSettlement && this.$refs.settlementPane.settlementValid);
            },
        },
        watch: {
            location(n, o) {
                if (n !== o) {
                    this.purchaseData.location_id = n.id;   
                }
            }
        },
        methods: {
            ...mapMutations({
                setIdentity: 'identity/setIdentity'
            }),
            buy() {
                this.purchaseData.supplier_id = this.purchaseData.supplier.id;

                this.$refs['buyInModal'].$once('hide', () => {
                    this.$refs['added'].open()
                });

                this.$refs['buyInModal'].close();

                let params = {
                    with: ['purchaseCost', 'purchaseCost.expense']
                };

                VehicleInstanceResource.buy(this.instance.id, this.purchaseData, params).then(response => {
                    this.instance = response.data;
                    this.setIdentity(this.purchaseData);
                    this.$refs['added'].setInstance(this.instance);

                    // Save the settlement details if provided.
                    if (this.showSettlement) {
                        this.$refs.settlementPane.setStockListing(this.instance.id)
                        this.$refs.settlementPane.save().then(() => {
                            this.isLoaded = true
                        })
                    } else {
                        this.isLoaded = true;
                    }
                }, error => { handleApiError(error); });
            },
            open(instance, contact = null) {
                this.isLoading = true;

                this.location = window.marque.ui.location;

                this.$set(this, 'purchaseData', {
                    manufacturer: instance.vehicle.manufacturer,
                    model: instance.vehicle.model,
                    derivative: instance.vehicle.derivative,
                    registration: instance.vehicle.registration?.vrm ?? '',
                    vin: instance.vehicle.vin,
                    miles: '',
                    supplier: contact ?? instance.owner,
                    owners: parseInt(instance.owners) + 1,
                    vat_rate: VatTariffs.NONE,
                    location_id: this.location.id,
                    purchase_date: new Date(),
                })

                this.instance = instance;

                this.$refs['buyInModal'].open();

                this.isLoading = false;
            },
        }
    }
</script>